import { render, staticRenderFns } from "./StockMovementViewLogs.vue?vue&type=template&id=669bc436"
import script from "./StockMovementViewLogs.vue?vue&type=script&lang=js"
export * from "./StockMovementViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports